import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";
import { CLASS_NAME, CLASS_GROUP, BRANCH, PAYMENT_DUE } from "../../constants";
import { useForm, useFormState, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ReactSelect from "react-select";
import PageLoader from "../../../common/Loader";
import { fetchBranchClassGroups,branchClassGroupLevelClassRoomsAction , resetBranchLevelClassGroups , resetBranchClassGroupLevelClassRooms} from "../../../redux/actions/feesActions";

const CreateBranch = (props) => {
  const { data, selectedEvent, branchData } = props;
  const dispatch = useDispatch()
  const { loader,branchLevelClassGroups ,branchClassGroupLevelClassRooms} = useSelector((state) => state.fees);
  const [show, setShow] = useState(props.show);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [selectedClassGroup, setSelectedClassGroup] = useState({});
  let validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    // ReactSelect:Yup.object().required("Name is required").nullable(),
  });
  if (selectedEvent === CLASS_GROUP) {
    validationSchema = Yup.object().shape({
      BranchId: Yup.object().required("Branch Name is required").nullable(),
      type: Yup.string().required("Field is required "),
      ClassGroupId: Yup.object()
        // .ensure()
        .when("type", {
          is: "fromList",
          then: Yup.object().required("Class Group is required ").nullable(),
        })
        .nullable(),
      name: Yup.string()
        .ensure()
        .when("type", {
          is: "custom",
          then: Yup.string().required("Name is required"),
        }),

      fee: Yup.string().required("Fee is required"),
    });
  } else if (selectedEvent === CLASS_NAME) {
    validationSchema = Yup.object().shape({
      BranchId: Yup.object().required("Branch Name is required").nullable(),
      ClassGroupId: Yup.object().required("Class Group Name is required").nullable(),
      type: Yup.string().required("Field is required "),
      ClassRoomId: Yup.object()
        // .ensure()
        .when("type", {
          is: "fromList",
          then: Yup.object().required("Class Group is required ").nullable(),
        })
        .nullable(),
      name: Yup.string()
        .ensure()
        .when("type", {
          is: "custom",
          then: Yup.string().required("Name is required"),
        }),
    });
  }
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: "fromList",
    },
    resolver: yupResolver(validationSchema),
  });
  // const branchWatch = watch("BranchId");
  useEffect(() => {
    setShow(props.show);
    reset();
  }, [props.show]);
  const handleClose = () => {
    setShow(false);
    props.closeModal();
  };
  const handleShow = () => setShow(true);
  const onSubmit = async (data) => {
    let reqParams = {};
    if (selectedEvent === CLASS_GROUP) {
      reqParams.BranchId = data.BranchId.value;
      reqParams.fee = data.fee;
      reqParams.type = data.type;
      if (data.type === "fromList") {
        reqParams.ClassGroupId = data.ClassGroupId.value;
      } else {
        const classGroupNames = branchLevelClassGroups.map(obj=> obj.label);
        if(classGroupNames.includes(data.name)){
          setError("name", { type: "focus",message: "ClassGroup name already existed", }, { shouldFocus: true });
          return true;
        }else{
          clearErrors(["name"])
          reqParams.name = data.name;
        }
        
      }
    } else if (selectedEvent === CLASS_NAME) {
      reqParams.BranchId = data.BranchId.value;
      reqParams.ClassGroupId = data.ClassGroupId.value;
      reqParams.type = data.type;
      if (data.type === "fromList") {
        reqParams.ClassRoomId = data.ClassRoomId.value;
      } else {
        const classRoomNames = branchClassGroupLevelClassRooms.map(obj=> obj.label);
        if(classRoomNames.includes(data.name)){
          setError("name", { type: "focus",message: "ClassRoom name already existed", }, { shouldFocus: true });
          return true;
        }else{
          clearErrors(["name"])
          reqParams.name = data.name;
        }
        // reqParams.name = data.name;
      }
    } else {
      reqParams = { ...data };
    }
    await props.create(reqParams);
    reset();
  };
  const onChangeAction = async(branchWatch) => {
    setValue("BranchId", branchWatch);
    setSelectedBranch(branchWatch)
    await dispatch(resetBranchLevelClassGroups())
   
    if (branchWatch && branchWatch.value ) {

      await dispatch(fetchBranchClassGroups({
        BranchId: branchWatch.value,
        disabled: true
      }))
      
      }
  };
  const onBranchChangeAction = async(branchWatch) => {
    setValue("BranchId", branchWatch);
    await dispatch(resetBranchLevelClassGroups())
 
    if (
      branchWatch &&
      branchWatch.value 
    ) {
      setSelectedBranch(branchWatch)
      setValue("ClassGroupId",null)
      setValue("ClassRoomId",null)
      await dispatch(fetchBranchClassGroups({
        BranchId: branchWatch.value,
        disabled: false
      }))
      }else{
        setValue("ClassGroupId",null)
        setValue("ClassRoomId",null)
      }
  };
  const onChangeGroupNameAction = async(groupWatch) => {
    setValue("ClassGroupId", groupWatch);
    setSelectedClassGroup(groupWatch);
    await dispatch(resetBranchClassGroupLevelClassRooms())
    if (groupWatch && groupWatch.value ) {
      setValue("ClassRoomId",null)
      await dispatch(branchClassGroupLevelClassRoomsAction({
        ClassGroupId: parseInt(groupWatch.value),
        BranchId: parseInt(selectedBranch.value),
        disabled: true
      }))
    }else{
      setValue("ClassRoomId",null)
    }
  };
  const renderSwitch = (param) => {
    switch (selectedEvent) {
      case BRANCH:
        return (
          <Form.Group
            as={Row}
            className="mb-3 required"
            controlId="formPlaintextEmail"
          >
            <Form.Label column sm="4">
              Branch Name
            </Form.Label>
            <Col sm="4">
              <Form.Control
                type="text"
                name="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                {...register("name")}
              ></Form.Control>
              <span className="invalid-feedback">{errors.name?.message}</span>
            </Col>
          </Form.Group>
        );
      case CLASS_GROUP:
        return (
          <>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="4">
                Select Branch Name
              </Form.Label>
              <Col sm="4">
                <Controller
                  name="BranchId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchData}
                        className={`${errors.BranchId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        onChange={onChangeAction}
                      />
                      <span className="invalid-feedback">
                        {errors.BranchId?.message}
                      </span>
                    </>
                  )}
                  {...register("BranchId")}
                />
              </Col>
            </Form.Group>
            <Form.Row>
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 required `}
                controlId="courseFee"
              >
                <Form.Label className="label">
                  <Form.Check
                    type="radio"
                    label="ClassGroup from list"
                    value={"fromList"}
                    // checked={isOtherAmount === "ToBePaid"}
                    inline
                    // onChange={handleChange}
                    {...register("type")}
                  />
                </Form.Label>
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchLevelClassGroups}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
              </Form.Group>
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4`}
                controlId="courseFee"
                style={{ paddingLeft: "11px" }}
              >
                <Form.Label className="label">
                  <Form.Check
                    type="radio"
                    label="Other"
                    value={"custom"}
                    // checked={isOtherAmount === "OtherAmount"}
                    inline
                    // onChange={handleChange}
                    {...register("type")}
                    // className={`${errors.isOtherAmount ? "is-invalid" : ""}`}
                  />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  // value={totalFee}
                  {...register("name")}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                />
                <span className="invalid-feedback">{errors.name?.message}</span>
              </Form.Group>
            </Form.Row>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="4">
                Fee
              </Form.Label>
              <Col sm="4">
                <Form.Control
                  type="text"
                  name="fee"
                  //   defaultValue={this.props.inputValues.state}
                  //   onChange={this.props.handleChange}
                  className={`form-control ${errors.fee ? "is-invalid" : ""}`}
                  {...register("fee")}
                ></Form.Control>
                <span className="invalid-feedback">{errors.fee?.message}</span>
              </Col>
            </Form.Group>
          </>
        );
      case CLASS_NAME:
        return (
          <>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Select Branch Name
              </Form.Label>
              <Col sm="6">
                <Controller
                  name="BranchId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchData}
                        className={`${errors.BranchId ? "is-invalid" : ""}`}
                        // isOptionDisabled={(option) => option.disabled}
                        onChange={onBranchChangeAction}
                      />
                      <span className="invalid-feedback">
                        {errors.BranchId?.message}
                      </span>
                    </>
                  )}
                  {...register("BranchId")}
                />
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Select Class Group Name
              </Form.Label>
              <Col sm="6">
                {" "}
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchLevelClassGroups}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
              </Col>
            </Form.Group>
            <Form.Row>
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required `}
                controlId="courseFee"
              >
                <Form.Label className="label">
                  <Form.Check
                    type="radio"
                    label="Class Name from list"
                    value={"fromList"}
                    // checked={isOtherAmount === "ToBePaid"}
                    inline
                    // onChange={handleChange}
                    {...register("type")}
                  />
                </Form.Label>
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchClassGroupLevelClassRooms}
                        className={`${errors.ClassRoomId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassRoomId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassRoomId")}
                />
              </Form.Group>
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6`}
                controlId="courseFee"
                style={{ paddingLeft: "11px" }}
              >
                <Form.Label className="label">
                  <Form.Check
                    type="radio"
                    label="Other"
                    value={"custom"}
                    // checked={isOtherAmount === "OtherAmount"}
                    inline
                    // onChange={handleChange}
                    {...register("type")}
                    // className={`${errors.isOtherAmount ? "is-invalid" : ""}`}
                  />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  // value={totalFee}
                  {...register("name")}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                />
                <span className="invalid-feedback">{errors.name?.message}</span>
              </Form.Group>
            </Form.Row>
          </>
        );
      default:
        return "foo";
    }
  };

  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create {selectedEvent} </Modal.Title>
        </Modal.Header>
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <PageLoader loader={loader} >
          <Card>
            <Card.Header> Branch Form </Card.Header>
            <Card.Body>
                {renderSwitch()}
                  
            </Card.Body>
          </Card>
        </PageLoader>
        </Modal.Body>
        <Modal.Footer>

          <Button
                    className="btn app-default-button btn btn-primary"
                    type="submit"
                  >
                    Create {selectedEvent}
                  </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={handleClose}>
              Save Changes
            </Button> */}
        </Modal.Footer>
        </Form>

      </Modal>
    </>
  );
};

export default CreateBranch;
